import PropTypes from 'prop-types';
import { ReactComponent as IconClose } from '../../public/images/svg/icon_close.svg';
import Button from '../Button/Button';
import { COPYSCAPE } from './enum';

const CopyscapeDrawer = ({ isOpen = false, onClick, data = null }) => {
  if (!isOpen) {
    return null;
  }

  const renderRadialPercentage = (percentage, semaphore) => {
    if (typeof percentage !== 'number' || isNaN(percentage)) {
      return null;
    }

    if (!Object.keys(COPYSCAPE).includes(semaphore)) {
      return null;
    }

    const { bgColor } = COPYSCAPE[semaphore];

    return (
      <div
        data-testid="copyscape-drawer-percentage-block"
        className={`relative flex items-center justify-center overflow-hidden rounded-full w-7 h-7 p-1 ${bgColor}`}
      >
        <span className="absolute text-[0.6rem] text-gray-600">{percentage}%</span>
      </div>
    );
  };

  const renderResult = (title, percentmatched, semaphore, url, textsnippet, viewurl) => (
    <div className="w-full" key={url}>
      <div className="flex justify-between items-baseline">
        <a
          className="text-sm underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
          href={viewurl}
          target="_blank"
          rel="noreferrer"
        >
          {title}
        </a>
        {renderRadialPercentage(percentmatched, semaphore)}
      </div>
      <div>
        <p data-testid="copyscape-drawer-result" className="m-0 p-0 text-xs">
          {textsnippet}
        </p>
        <small
          data-testid="copyscape-drawer-result-url"
          className="text-xs leading-3 text-green-700"
        >
          {url}
        </small>
      </div>
    </div>
  );

  const renderNoResults = () => (
    <div className="w-full" key="copyscape-no-results">
      <div className="flex justify-between items-baseline">
        <p data-testid="copyscape-drawer-result" className="m-0 p-0 text-sm">
          No similar results found for requested text
        </p>
      </div>
    </div>
  );

  return (
    <div
      data-testid="copyscape-drawer"
      className={
        'fixed overflow-hidden z-50 inset-0 transform ease-in-out ' +
        (isOpen
          ? ' max-w-full duration-300 translate-x-0  '
          : ' max-w-[4.5rem] transition-all -translate-x-0  ')
      }
    >
      <div
        className={
          'w-screen left-0 absolute bg-grey-100 border-grey-200 border-l border-solid h-full duration-300 ease-in-out transition-all transform  ' +
          (isOpen ? ' max-w-lg translate-x-copyscape-drawer ' : ' max-w-0 translate-x-full ')
        }
      >
        <div className="relative w-screen max-w-lg flex flex-col justify-between space-y-6 pt-20 pb-10 overflow-y-auto overflow-x-hidden h-full no-scrollbar">
          <div
            className={
              'h-screen p-3 flex flex-col gap-6 items-end transition-all transform duration-300' +
              (isOpen ? ' w-full' : ' w-16 ')
            }
          >
            <div className="flex w-full items-center justify-between px-2">
              <h3 className="text-xl font-semibold leading-normal m-0">Copyscape Results</h3>
              <Button
                dataTest="copyscape-drawer-open-menu"
                name="copyscape-drawerOpenMenu"
                className="bg-white rounded p-2 w-10"
                onClick={onClick}
                icon={<IconClose />}
              />
            </div>

            <div
              data-testid="copyscape-drawer-children"
              className="max-w-[472px] w-full grow mx-2 flex flex-col gap-4 items-start overflow-y-scroll no-scrollbar"
            >
              {data?.result?.length > 0
                ? data?.result?.map(
                    ({ title, percentmatched, semaphore, url, textsnippet, viewurl }) =>
                      renderResult(title, percentmatched, semaphore, url, textsnippet, viewurl)
                  )
                : renderNoResults()}
            </div>
          </div>
        </div>
      </div>
      {isOpen ? (
        <div
          className=" w-screen h-screen cursor-pointer "
          data-testid="copyscape-drawer-background-overlay"
          onClick={onClick}
        />
      ) : null}
    </div>
  );
};

CopyscapeDrawer.propTypes = {
  data: PropTypes.shape({
    semaphore: PropTypes.string,
    result: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        percentmatched: PropTypes.number,
        url: PropTypes.string,
        textsnippet: PropTypes.string,
        viewurl: PropTypes.string
      })
    )
  }),
  onClick: PropTypes.func,
  isOpen: PropTypes.bool
};

export default CopyscapeDrawer;
